import { Button, MenuItem } from '@blueprintjs/core'
import { ItemPredicate, Suggest } from '@blueprintjs/select'
import { getAllUsersQuery } from 'ui-io/queries/tasks/task-user-list-query'
import React from 'react'
import { useQuery } from 'react-query'
import { USERS_TEAMS } from '../utils/admin-io'

const SuggestUserInput = ({
  setUsername,
  username,
}: {
  setUsername: (username: string) => void
  username?: string
}) => {
  const SuggestUser = Suggest.ofType<string>()

  const allUserListConnection = useQuery(
    getAllUsersQuery({ team: USERS_TEAMS.YANTRIX_ADMIIN_ALL }),
  )
  const allUserList = allUserListConnection.data
  const filterUser: ItemPredicate<string> = (
    query,
    item,
    _index,
    exactMatch,
  ) => {
    const normalizedTitle = item.toLowerCase()
    const normalizedQuery = query.toLowerCase()

    if (exactMatch) {
      return normalizedTitle === normalizedQuery
    } else {
      return item.indexOf(normalizedQuery) >= 0
    }
  }
  return (
    <SuggestUser
      itemPredicate={filterUser}
      fill
      inputProps={{
        rightElement: username ? (
          <Button icon="cross" minimal onClick={() => setUsername('')} />
        ) : undefined,
      }}
      items={!allUserList ? [] : allUserList}
      noResults={<MenuItem disabled={true} text="No results." />}
      onItemSelect={(userid: string) => {
        setUsername(userid)
      }}
      itemRenderer={(item, itemProps) => (
        <MenuItem
          key={item}
          active={itemProps.modifiers.active}
          text={item}
          onClick={itemProps.handleClick}
        />
      )}
      inputValueRenderer={(userid) => (username ? userid : '')}
      popoverProps={{ minimal: true }}
    />
  )
}
export default SuggestUserInput
